module.exports = __webpack_public_path__ + "static/media/UNID_licenciatura.8b1cd4f1.svg";